import resourcesService from './resourcesService';

export default resourcesService;
